/* eslint-disable react/no-duplicate-key */
import React, { Fragment, useMemo } from "react";

import {
	ActionMenuButton,
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuSeparator,
	DropdownMenuShortcut,
	DropdownMenuTrigger
} from "../../../components";
import { getShortcutKey } from "../../../utils/plateform";

function HeadingButton(props) {
	const active = useMemo(() => {
		const find = props?.items?.find(k => k.isActive());

		if (find && !find.default) {
			return {
				...find
			};
		}
		const item = {
			title: props.tooltip,
			level: 0,
			isActive: () => false
		};
		return item;
	}, [props]);

	return (
		<DropdownMenu>
			<DropdownMenuTrigger disabled={props?.disabled} asChild>
				<ActionMenuButton
					title={active?.title}
					tooltip={props?.tooltip}
					disabled={props?.disabled}
					icon="MenuDown"
				/>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="richtext-w-full">
				{props?.items?.map((item, index) => {
					return (
						<Fragment key={`heading-k-${index}`}>
							<DropdownMenuCheckboxItem
								checked={active?.title === item.title}
								onClick={item.action}
							>
								<div
									className={`richtext-ml-1 richtext-h-full heading-${item.level}`}
								>
									{item.title}
								</div>
								{!!item?.shortcutKeys?.length && (
									<DropdownMenuShortcut className="richtext-pl-4">
										{item?.shortcutKeys
											?.map(item => getShortcutKey(item))
											.join(" ")}
									</DropdownMenuShortcut>
								)}
							</DropdownMenuCheckboxItem>
							{item.level === 0 && <DropdownMenuSeparator />}
						</Fragment>
					);
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}

export default HeadingButton;
